<script setup lang="ts">
import { RouterWrapper } from '@bagelink/vue'
import { initFacebookPixel } from '@/store/facebookPixels'
import { onMounted } from 'vue'

onMounted(() => {
	initFacebookPixel()
})
</script>

<template>
	<ModalContainer />
	<div>
		<RouterWrapper class="relative" />
	</div>
</template>
